import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["relevanceCheckbox", "scaleRadio"]

  toggleFromCheckbox() {
    if (this.relevanceCheckboxTarget.checked) {
      this.scaleRadioTargets.forEach(radio => radio.checked = false)
    }
  }

  toggleFromRadio(event) {
    if (event.target.checked) {
      this.relevanceCheckboxTarget.checked = false
    }
  }
}
